module.exports = __webpack_public_path__ + "img/huaydragon-logo-dark.5c643a64.png";